import { render, staticRenderFns } from "./topay.vue?vue&type=template&id=dec6c246&scoped=true&"
import script from "./topay.vue?vue&type=script&lang=js&"
export * from "./topay.vue?vue&type=script&lang=js&"
import style0 from "./topay.vue?vue&type=style&index=0&id=dec6c246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec6c246",
  null
  
)

export default component.exports